import React from 'react';
import styled, { css } from 'styled-components';

import useUI from 'hooks/use-ui';
import { useRemoteComponent, RemoteComponentSlot } from 'hooks/use-remote-component';
import CoreMenuHeader from './core-menu-header';
import StoreFrontHeader from './store-front-header';

export default function Header(props): JSX.Element {
  const { isStoreFront, isKiosk } = useUI();

  const ResolvedHeader = useRemoteComponent(RemoteComponentSlot.Header, { fallback: StoreFrontHeader });
  const ResolvedNavigation = useRemoteComponent(RemoteComponentSlot.Navigation, { fallback: CoreMenuHeader });

  return (
    <Container isKiosk={isKiosk}>
      {(isStoreFront || isKiosk) && <ResolvedHeader />}
      <ResolvedNavigation {...props} />
    </Container>
  );
}

const Container = styled.header`
  width: 100%;
  ${({ isKiosk }) =>
    isKiosk &&
    css`
      position: sticky;
      z-index: 20;
      top: 0;
    `}
`;
